import { useEffect } from "react";
import queryString from 'query-string';
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";
import { useRecoilState, useSetRecoilState, useResetRecoilState } from "recoil";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";
import { encryptJSON, decryptJSON, encryptString } from 'src/shared/global/cryptoJSUtilities';

const AgendarHoraExterno = () => {
    const query = queryString.parse(window.location.search)
    const [dayDefaultAvailable, setDayDefaultAvailable] = useRecoilState(dayDefaultAvailableState);
    const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
    const resetFilterSearchSelected = useResetRecoilState(filterSearchSelectedState);
    //const { loadDReservationCanceled, getDaysAvailable } = useSearchHours();
    const { loadDReservationCanceled, loadDaysAvailableAndDefault } = useSearchHours();
    
    useEffect(() => {
        (async function () {
            if (query.ext && query.ext !== "") {
                let splitted = window.location.search.split("ext=");
                const objDecryptJSON = decryptJSON(splitted[1]);
                
                resetFilterSearchSelected(); 
                setFilterSearchSelected({
                    ...objDecryptJSON,
                    searchExternoSelected: {
                        value: '1'
                    },  
                });
                    setTimeout(() => {
                        loadDaysAvailableAndDefault()
                    }, 0)
                // }
            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null;
}

export default AgendarHoraExterno